module.exports = __webpack_public_path__ + "img/tree-04-h-trunk.a3dc3813.png";